import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
const MoneyFormatContext = /*#__PURE__*/ React.createContext({
    alwaysShowCents: false
});
export const useMoneyFormat = ()=>useContext(MoneyFormatContext);
export const MoneyFormatProvider = (param)=>{
    let { children, value } = param;
    return /*#__PURE__*/ _jsx(MoneyFormatContext.Provider, {
        value: value,
        children: children
    });
};
